import { WorkspaceSegments } from "../constants/workspaceSegments";

export function isPassengerTransportWorkspace(segment) {
  return segment === WorkspaceSegments.PassengerTransport;
}

export function productsNavI18nKey(segment) {
  return isPassengerTransportWorkspace(segment) ? "nav.trechos" : "nav.products";
}

export function productsPageTitleI18nKey(segment) {
  return isPassengerTransportWorkspace(segment) ? "productsPage.titleTrechos" : "productsPage.title";
}

export function categoriesNavI18nKey(segment) {
  return isPassengerTransportWorkspace(segment) ? "nav.categoriesTrechos" : "nav.categories";
}

export function categoriesPageTitleI18nKey(segment) {
  return isPassengerTransportWorkspace(segment) ? "categoriesPage.titleTrechos" : "categoriesPage.title";
}

/** Rótulo de item do menu lateral (namespace `app`). */
export function resolveNavItemLabel(item, segment, tNav) {
  if (item.res === "billing") return tNav("nav.billingWorkspace");
  if (item.res === "products") return tNav(productsNavI18nKey(segment));
  if (item.res === "categories") return tNav(categoriesNavI18nKey(segment));
  if (item.label) return item.label;
  if (item.textKey) return tNav(item.textKey);
  return "";
}

/**
 * Recursos só do segmento transporte rodoviário (mesmo critério do menu / guards de BPe).
 * Chaves de escopo não mudam — só o que o catálogo de cargos exibe.
 */
export const PASSENGER_TRANSPORT_ONLY_PERMISSION_KEYS = new Set([
  "bpe",
  "passagens",
  "cities",
]);

/** Labels de catálogo de cargos quando o workspace é transporte rodoviário. */
export const PASSENGER_TRANSPORT_PERMISSION_LABELS = {
  products: "Trechos",
  products_stock: "Estoque de Trechos",
  products_price: "Preço de Trechos",
  categories: "Categorias de Trechos",
};

/**
 * Filtra e renomeia o catálogo de permissões conforme o segmento do workspace.
 * Não altera keys (`products.view` continua `products.view`).
 */
export function adaptPermissionCatalogForSegment(catalog, segment) {
  if (!Array.isArray(catalog)) return catalog;
  const isPassenger = isPassengerTransportWorkspace(segment);

  return catalog
    .map((mod) => ({
      ...mod,
      resources: (mod.resources || [])
        .filter((r) => isPassenger || !PASSENGER_TRANSPORT_ONLY_PERMISSION_KEYS.has(r.key))
        .map((r) => {
          const nextLabel =
            isPassenger && PASSENGER_TRANSPORT_PERMISSION_LABELS[r.key]
              ? PASSENGER_TRANSPORT_PERMISSION_LABELS[r.key]
              : r.label;
          return nextLabel === r.label ? r : { ...r, label: nextLabel };
        }),
    }))
    .filter((mod) => (mod.resources || []).length > 0);
}
